import request from "./_request"

const ConfigSpaceService = {
  // 国内域名拉去配置信息
  getConfig(namespace, key) {
    const url = `/aries-confucius/api/common/config`
    return request.get(url, { params: { namespace, key } }).then((res) => res.data)
  },

  // 海外域名拉去配置信息
  getZetaConfig(namespace, key) {
    const url = `/aries-zeta-confucius/api/common/config`
    return request.get(url, { params: { namespace, key } }).then((res) => res.data)
  }
}

export default ConfigSpaceService
